<template>
  <a-form-field v-bind="formFieldAttrs">
    <!--
      Adding @change to mitigate weird Microsoft Edge
      behaviour that uses change instead of input on
      select fields.
     -->
    <select
      ref="input"
      slot-scope="slotProps"
      :aria-describedby="slotProps.describedby"
      :aria-invalid="hasError ? 'true' : 'false'"
      :id="id"
      v-bind="$attrs"
      class="form-input form-input--select"
      v-on="listeners"
      @change="$emit('input', $event.target.value)"
    >
      <slot/>
    </select>

  </a-form-field>
</template>

<script>
import AFormField from '@/components/form/atoms/AFormField'
import BFormInput from '@/components/form/base/BFormInput'

export default {
  name: 'CFormSelect',

  components: {
    AFormField
  },

  extends: BFormInput
}
</script>
